import { ACCESS_TOKEN_NAME, JSON_CONTENT_TYPE } from '../../_constant/constants';
import { WarningDeleteWarningDto } from '../../_dto/_warning/WarningDeleteWarningDto';
import { IApiParams } from '../../_interface/IApiParams';
import { getApi } from '../getApi';

export const apiDeleteDocument = async (warningDeleteWarningDto: WarningDeleteWarningDto) => {
  const params: IApiParams = {
    url: '/warning/deleteWarning.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': localStorage.getItem(ACCESS_TOKEN_NAME), 
    },
  };
  return getApi(params, 'DELETE', warningDeleteWarningDto);
};